import { ElementType, ReactNode } from "react";

import sanitizeHtml from "sanitize-html";

export type SanitizedHtmlProps = {
    readonly innerHTML: string | InnerHTML | ReactNode[];
    readonly tagName?: ElementType;
};

export const SanitizedHtml = ({
    innerHTML,
    tagName: Component = "span"
}: SanitizedHtmlProps) => {
    if (typeof innerHTML === "string") {
        return (
            <Component
                dangerouslySetInnerHTML={{ __html: sanitizeHtml(innerHTML) }}
            />
        );
    } else {
        return null;
    }
};
